import api from './client';

export const projectsApi = {
  list: () => api.get('/projects').then((r) => r.data),
  get: (id: string) => api.get(`/projects/${id}`).then((r) => r.data),
  create: (data: { name: string; notes?: string; startDate?: string; endDate?: string }) => api.post('/projects', data).then((r) => r.data),
  update: (id: string, data: Record<string, unknown>) => api.patch(`/projects/${id}`, data).then((r) => r.data),
  cancel: (id: string) => api.delete(`/projects/${id}`).then((r) => r.data),
  hardDelete: (id: string) => api.delete(`/projects/${id}`, { params: { permanent: 'true' } }).then((r) => r.data),

  assignJobs: (id: string, jobIds: string[]) => api.post(`/projects/${id}/jobs`, { jobIds }).then((r) => r.data),
  removeJob: (id: string, jobId: string) => api.delete(`/projects/${id}/jobs/${jobId}`).then((r) => r.data),

  listNotes: (id: string) => api.get(`/projects/${id}/notes`).then((r) => r.data),
  addNote: (id: string, content: string) => api.post(`/projects/${id}/notes`, { content }).then((r) => r.data),
  updateNote: (id: string, noteId: string, content: string) => api.patch(`/projects/${id}/notes/${noteId}`, { content }).then((r) => r.data),
  deleteNote: (id: string, noteId: string) => api.delete(`/projects/${id}/notes/${noteId}`).then((r) => r.data),

  getCrewSchedule: (id: string) => api.get(`/projects/${id}/crew-schedule`).then((r) => r.data),

  getSubHireSummary: (id: string) => api.get(`/projects/${id}/subhire-summary`).then((r) => r.data),
  listSubHireOrders: (id: string) => api.get(`/projects/${id}/subhire-orders`).then((r) => r.data),
  createSubHireOrder: (id: string, data: Record<string, unknown>) => api.post(`/projects/${id}/subhire-orders`, data).then((r) => r.data),
  updateSubHireOrder: (id: string, orderId: string, data: Record<string, unknown>) => api.patch(`/projects/${id}/subhire-orders/${orderId}`, data).then((r) => r.data),
  deleteSubHireOrder: (id: string, orderId: string) => api.delete(`/projects/${id}/subhire-orders/${orderId}`).then((r) => r.data),
  addSubHireOrderLine: (id: string, orderId: string, data: Record<string, unknown>) => api.post(`/projects/${id}/subhire-orders/${orderId}/lines`, data).then((r) => r.data),
  updateSubHireOrderLine: (id: string, orderId: string, lineId: string, data: Record<string, unknown>) => api.patch(`/projects/${id}/subhire-orders/${orderId}/lines/${lineId}`, data).then((r) => r.data),
  deleteSubHireOrderLine: (id: string, orderId: string, lineId: string) => api.delete(`/projects/${id}/subhire-orders/${orderId}/lines/${lineId}`).then((r) => r.data),

  // Timeline
  listTimeline: (id: string) => api.get(`/projects/${id}/timeline`).then((r) => r.data),
  addTimelineEntry: (id: string, data: Record<string, unknown>) =>
    api.post(`/projects/${id}/timeline`, data).then((r) => r.data),
  updateTimelineEntry: (id: string, entryId: string, data: Record<string, unknown>) =>
    api.patch(`/projects/${id}/timeline/${entryId}`, data).then((r) => r.data),
  deleteTimelineEntry: (id: string, entryId: string) =>
    api.delete(`/projects/${id}/timeline/${entryId}`).then((r) => r.data),
};
